'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WindowScroller = function (_React$Component) {
  _inherits(WindowScroller, _React$Component);

  function WindowScroller() {
    var _temp, _this, _ret;

    _classCallCheck(this, WindowScroller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.scrollTop = 0, _this.scrollDirection = null, _this.time = Date.now(), _this.timer = null, _this.handleScroll = function (event) {
      _this.throttle(event);
      var pageTopCallback = _this.props.pageTopCallback;


      if (pageTopCallback && _this.getScrollTop() === 0) {
        pageTopCallback();
      }
    }, _this.throttle = function (event) {
      var newTime = Date.now();
      window.clearTimeout(_this.timer);
      var pollRate = _this.props.pollRate;

      _this.timer = window.setTimeout(_this.scrollEnd, pollRate);

      if (_this.time + pollRate - newTime < 0) {
        _this.handleThrottledScroll(event);
        _this.time = newTime;
      }
    }, _this.scrollEnd = function () {
      // Set the scroll top on scroll end
      _this.scrollTop = _this.getScrollTop();
    }, _this.handleThrottledScroll = function (e) {
      var scrollTop = _this.getScrollTop();
      var oldScrollTop = _this.scrollTop;
      var _this$props = _this.props,
          onScroll = _this$props.onScroll,
          getDirection = _this$props.getDirection;


      _this.scrollTop = scrollTop;

      if (onScroll) {
        onScroll(e, scrollTop);
      }

      if (getDirection) {
        getDirection(scrollTop >= oldScrollTop);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  WindowScroller.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  };

  WindowScroller.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.clearTimeout(this.timer);
  };

  WindowScroller.prototype.getScrollTop = function getScrollTop() {
    return window.pageYOffset;
  };

  WindowScroller.prototype.render = function render() {
    return this.props.children;
  };

  return WindowScroller;
}(_react2.default.Component);

WindowScroller.defaultProps = {
  pollRate: 30
};

WindowScroller.propTypes = process.env.NODE_ENV !== "production" ? {
  getDirection: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  pageTopCallback: _propTypes2.default.func,
  children: _propTypes2.default.node,
  pollRate: _propTypes2.default.number.isRequired
} : {};

exports.default = WindowScroller;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/window-scroller/WindowScroller.js
// module id = 1408
// module chunks = 249